import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../App';
import api from '../utils/api';
import { generateCodeVerifierAndChallenge, buildAuthUrl } from '../utils/oidc';

export default function Login() {
  const { setCurrentUser, setUsers } = useContext(UserContext);
  const [tab, setTab] = useState('owner');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const hasCognito = Boolean(process.env.REACT_APP_COGNITO_DOMAIN && process.env.REACT_APP_COGNITO_CLIENT_ID);

  const handleOwnerLogin = async e => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/auth/login', { email, password });
      let user = { id: res.data.id, email: res.data.email, name: res.data.name || '', role: res.data.role || 'owner', type: res.data.active_context || (res.data.role === 'nominee' ? 'nominee' : 'owner') };
      if ((!user.id || !user.email) && res.data?.token) {
        try {
          const token = res.data.token;
          const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/')));
          user = {
            id: payload.id || payload.sub || user.id,
            email: payload.email || user.email,
            name: payload.name || user.name || '',
            role: payload.role || (payload.type === 'nominee' ? 'nominee' : 'owner'),
            type: payload.active_context || payload.type || (payload.role === 'nominee' ? 'nominee' : 'owner')
          };
        } catch {}
      }
      setCurrentUser(user);
      try { localStorage.setItem('currentUser', JSON.stringify(user)); } catch {}
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid username or password');
      if (err.response && err.response.data) console.error('Login error:', err.response.data);
    }
  };

  const handleNomineeLogin = async e => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/auth/login', { email, password });
      let user = { id: res.data.id, email: res.data.email, name: res.data.name || '', role: res.data.role || 'nominee', type: res.data.active_context || 'nominee' };
      if ((!user.id || !user.email) && res.data?.token) {
        try {
          const token = res.data.token;
          const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/')));
          user = {
            id: payload.id || payload.sub || user.id,
            email: payload.email || user.email,
            name: payload.name || user.name || '',
            role: payload.role || (payload.type === 'nominee' ? 'nominee' : 'owner'),
            type: payload.active_context || payload.type || (payload.role === 'nominee' ? 'nominee' : 'owner')
          };
        } catch {}
      }
      setCurrentUser(user);
      try { localStorage.setItem('currentUser', JSON.stringify(user)); } catch {}
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid credentials');
      if (err.response && err.response.data) console.error('Nominee login error:', err.response.data);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--mist-100)' }}>
      <div style={{ background: '#fff', padding: 32, borderRadius: 16, boxShadow: 'var(--shadow-soft)', border: '1px solid var(--mist-200)', minWidth: 340, width: 380 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <img src="/logo.svg" alt="ProVault" style={{ height: 32 }} />
        </div>
        {!hasCognito && (
        <div style={{ display: 'flex', marginBottom: 24 }}>
          <button
            onClick={() => { setTab('owner'); setError(''); }}
            style={{ flex: 1, padding: 12, fontWeight: 600, fontSize: 17, background: tab === 'owner' ? 'var(--sage-600)' : 'var(--mist-200)', color: tab === 'owner' ? '#fff' : 'var(--dusk-700)', border: 'none', borderRadius: '12px 0 0 12px', cursor: 'pointer' }}
          >
            Owner Login
          </button>
          <button
            onClick={() => { setTab('nominee'); setError(''); }}
            style={{ flex: 1, padding: 12, fontWeight: 600, fontSize: 17, background: tab === 'nominee' ? 'var(--sage-600)' : 'var(--mist-200)', color: tab === 'nominee' ? '#fff' : 'var(--dusk-700)', border: 'none', borderRadius: '0 12px 12px 0', cursor: 'pointer' }}
          >
            Nominee Login
          </button>
        </div>
        )}
        {!hasCognito && tab === 'owner' && (
          <form onSubmit={handleOwnerLogin} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <label style={{ fontWeight: 600, color: 'var(--dusk-700)' }}>Email</label>
            <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" style={{ padding: '10px 12px', borderRadius: 12, border: '1px solid var(--mist-300)', fontSize: 16 }} autoFocus={tab === 'owner'} autoComplete="username" name="username" />
            <label style={{ fontWeight: 600, color: 'var(--dusk-700)' }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" style={{ padding: '10px 12px', borderRadius: 12, border: '1px solid var(--mist-300)', fontSize: 16 }} autoComplete="current-password" name="current-password" />
            {error && <div style={{ color: '#d32f2f', fontWeight: 500, textAlign: 'center', marginTop: 4 }}>{error}</div>}
            <button type="submit" className="btn btn-primary" style={{ marginTop: 10, width: '100%', justifyContent: 'center' }}>Login</button>
          </form>
        )}
        {!hasCognito && tab === 'nominee' && (
          <form onSubmit={handleNomineeLogin} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <label style={{ fontWeight: 600, color: 'var(--dusk-700)' }}>Email</label>
            <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" style={{ padding: '10px 12px', borderRadius: 12, border: '1px solid var(--mist-300)', fontSize: 16 }} autoFocus={tab === 'nominee'} autoComplete="username" name="username" />
            <label style={{ fontWeight: 600, color: 'var(--dusk-700)' }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password (default: password1)" style={{ padding: '10px 12px', borderRadius: 12, border: '1px solid var(--mist-300)', fontSize: 16 }} autoComplete="current-password" name="current-password" />
            {error && <div style={{ color: '#d32f2f', fontWeight: 500, textAlign: 'center', marginTop: 4 }}>{error}</div>}
            <button type="submit" className="btn btn-primary" style={{ marginTop: 10, width: '100%', justifyContent: 'center' }}>Login</button>
          </form>
        )}
        {hasCognito && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ color: 'var(--dusk-700)', textAlign: 'center', marginBottom: 8 }}>Sign in with Cognito</div>
            <button type="button" onClick={async ()=>{
              const { verifier, challenge } = await generateCodeVerifierAndChallenge();
              sessionStorage.setItem('pkce_verifier', verifier);
              const domain = (typeof window !== 'undefined' && window.__COGNITO_DOMAIN__) || process.env.REACT_APP_COGNITO_DOMAIN;
              const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
              const redirectUri = window.location.origin + '/auth/callback';
              const scope = 'openid email profile phone';
              const url = buildAuthUrl({ domain, clientId, redirectUri, scope, codeChallenge: challenge });
              window.location.assign(url);
            }} style={{ marginTop: 8, width: '100%', justifyContent: 'center' }}>Continue</button>
          </div>
        )}
        <div style={{ textAlign: 'center', marginTop: 12, fontSize: 14, display: 'grid', gap: 6 }}>
          {!hasCognito && <div>
            New to ProVault? <button type="button" onClick={() => navigate('/register')} style={{ background: 'none', border: 'none', color: 'var(--sage-700)', textDecoration: 'underline', cursor: 'pointer' }}>Create owner account</button>
          </div>}
          {!hasCognito && <div>
            Only acting as a nominee? <button type="button" onClick={() => navigate('/register/nominee')} style={{ background: 'none', border: 'none', color: 'var(--sage-700)', textDecoration: 'underline', cursor: 'pointer' }}>Create nominee account</button>
          </div>}
        </div>
      </div>
    </div>
  );
} 